import { styled as o } from "styled-components";
import { Colors as r } from "../../../../styles/colors/index.js";
import { DarkThemeQuery as e, DarkNinjaThemeQuery as t } from "../../../../styles/themes/index.js";
import { BaseCommentContent as a } from "../BaseCommentContent/index.js";
const d = o.div`
  display: flex;
  grid-area: content;
  align-items: flex-start;
  opacity: 1;
`, s = o(a)`
  & {
    background-color: rgb(${r.Silver});
    border-left: 3px solid rgb(${r.Gray});
    border-radius: 4px;

    ${e}, ${t} {
      background-color: rgb(${r.Coal});
    }
  }
`;
export {
  s as ParentCommentContent,
  d as ParentContainer
};
